import React from 'react';
import { ContinueToPaymentButton } from '@fiverr-private/expert_sourcing_domain_selection_drawer';
import { Button, ButtonProps } from '@fiverr-private/button';
import { DomainType } from '@fiverr-private/expert_sourcing_domain_selection_drawer/dist/esm/src/lib/types/domain';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';

type VariantType = ButtonProps['variant'];
interface ExpertSourcingPaymentButtonProps {
    domain: DomainType;
    source: string;
    buttonVairant: VariantType;
    children?: React.ReactNode;
}

const ExpertSourcingPaymentButton = ({ domain, source, buttonVairant, children }: ExpertSourcingPaymentButtonProps) => {
    const { userId } = getContext();

    const isUserLoggedIn = !!userId;

    const openSignUpModal = () => {
        if (window?.openSignUpModal) {
            window.openSignUpModal({ source }, { source });
        }
    };

    return (
        <Container width="fit-content">
            {isUserLoggedIn ? (
                <ContinueToPaymentButton domain={domain} source={source} buttonVairant={buttonVairant}>
                    {children}
                </ContinueToPaymentButton>
            ) : (
                <Button onClick={openSignUpModal} variant={buttonVairant} fullWidth>
                    {children}
                </Button>
            )}
        </Container>
    );
};

export default ExpertSourcingPaymentButton;
